module.exports = __webpack_public_path__ + "img/图1-11  使用模型预测新样本.9e8ef6a1.png";